var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCompare(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 55,
    height: 24,
    viewBox: "0 0 55 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.0091 3.66699C5.40078 3.66699 1.67578 7.39199 1.67578 12.0003C1.67578 16.6087 5.40078 20.3337 10.0091 20.3337C14.6174 20.3337 18.3424 16.6087 18.3424 12.0003C18.3424 7.39199 14.6174 3.66699 10.0091 3.66699Z",
    fill: "#A8A7CC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26.7198 15.2897L29.3098 12.6997C29.6998 12.3097 29.6998 11.6797 29.3098 11.2897L26.7198 8.69973C26.0898 8.07973 25.0098 8.51973 25.0098 9.40973V14.5797C25.0098 15.4797 26.0898 15.9197 26.7198 15.2897Z",
    fill: "#A8A7CC"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M44.0091 3.66699C39.4008 3.66699 35.6758 7.39199 35.6758 12.0003C35.6758 16.6087 39.4008 20.3337 44.0091 20.3337C48.6174 20.3337 52.3424 16.6087 52.3424 12.0003C52.3424 7.39199 48.6174 3.66699 44.0091 3.66699Z",
    fill: "#A8A7CC"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompare);
export default __webpack_public_path__ + "static/media/compare.d1978884e0bf404ab7b792ea22673811.svg";
export { ForwardRef as ReactComponent };